import { render, staticRenderFns } from "./DataRefreshMenu.vue?vue&type=template&id=3bc2ab38"
import script from "./DataRefreshMenu.vue?vue&type=script&lang=js"
export * from "./DataRefreshMenu.vue?vue&type=script&lang=js"
import style0 from "./DataRefreshMenu.vue?vue&type=style&index=0&id=3bc2ab38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports